"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _Button = _interopRequireDefault(require("../Button"));

var _Container = _interopRequireDefault(require("../Filter/Container"));

var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));

var _default = function _default(_ref) {
  var enableToNext = _ref.enableToNext,
      onCancel = _ref.onCancel,
      onNext = _ref.onNext;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-around h-full sm:w-60vw"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center flex-1 text-3xl font-semibold sm:text-6xl"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark"
  }, t('settings.splitInbox.name.title')), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "name",
    render: function render(_ref2) {
      var field = _ref2.field,
          form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, field, {
        onChange: function onChange(e) {
          form.setFieldValue(field.name, e.target.value);
        },
        autoFocus: true,
        spellCheck: "false",
        autoComplete: "off",
        className: "font-semibold bg-transparent border-b-4 rounded-none border-primary text-primary"
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: "name",
    showAfterTouch: false
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex my-10 sm:block"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    color: "secondary",
    className: "flex-1 sm:w-56 border mr-4",
    onClick: onCancel
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    onClick: onNext,
    disabled: !enableToNext,
    className: "flex-1 sm:w-56"
  }, t('button.next')))));
};

exports["default"] = _default;
//# sourceMappingURL=Name.js.map